import { faSortDown, faSortUp } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import { get, isEmpty } from "lodash";
import React, { useState } from "react";
import { useDeepEffect } from "../../../abstracts";
import { AddToolTip, FieldInput } from "../../../components";
import TieredParticipantBalanceCard from "./TieredParticipantBalanceCard";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";

// const handleSearch = (event) => {
//     setSearchInput(event.target.value);
// };

// investmentInformation = investmentInformation.filter(item => {
//     const name = item.name.toLowerCase();
//     const cusip = item?.cusip?.toLowerCase();
//     return name?.includes(searchInput.toLowerCase()) && cusip?.includes(searchInput.toLowerCase());
// });

const data = [
  {
    SNo: 1,
    AmountRange: "$5000.01 to $10000.01",
    FeePercentage: "12%",
  },
  {
    SNo: 2,
    AmountRange: "$5000.01 to $10000.01",
    FeePercentage: "14%",
  },
  {
    SNo: 3,
    AmountRange: "$5000.01 to $10000.01",
    FeePercentage: "13%",
  },
  {
    SNo: 4,
    AmountRange: "$5000.01 to $10000.01",
    FeePercentage: "10%",
  },
];

const sorterUp = (sortBy) => (a, b) =>
  a[sortBy]?.toLowerCase() > b[sortBy]?.toLowerCase() ? 1 : -1;
const sorterDown = (sortBy) => (a, b) =>
  a[sortBy]?.toLowerCase() < b[sortBy]?.toLowerCase() ? 1 : -1;

const TieredParticiantBalance = ({ addSpecificationdata }) => {
  console.log("addSpecificationdataty", addSpecificationdata);
  let feeTier = addSpecificationdata?.feeTiers;
  const [participantBalance, setPartcipantBalance] = useState([]);
  useDeepEffect(() => {
    setPartcipantBalance(feeTier != undefined ? feeTier : []);
  }, [feeTier]);

  const tieredParticipantHeader = [
    {
      label: "S.No",
      columnName: "sno",
      width: "10%",
    },
    // {
    //   label: "Condition",
    //   columnName: "condition",
    //   width: "20%",
    // },
    {
      label: "Account balance from / to",
      columnName: "amount",
      width: "40%",
    },
    {
      label:
        addSpecificationdata?.tierComputationSubType === 1
          ? "Fixed amount"
          : addSpecificationdata?.formulaType === 1
          ? "Fee percentage"
          : "Basis points",
      columnName: "feePercentage",
      width: "20%",
    },
  ];

  return (
    <>
      {!isEmpty(participantBalance) && (
        <>
          <p className="mt-1 ml-3 ft-17 fw-600 black">
            Tiered Fees Balanced On Participant Balance
            {participantBalance.length < 10 ? (
              <p className="ml-1 mt-1 ft-12 fw-400 grey">
                0{participantBalance.length} Tier fees
              </p>
            ) : (
              <p className="ml-1 mt-1 ft-12 fw-400 grey">
                {participantBalance.length}Tier fees
              </p>
            )}
          </p>

          <div
            className="payroll-columns w-100"
            style={{ display: "flex", marginLeft: "20px" }}
          >
            {tieredParticipantHeader.map((item, ind) => (
              <div
                className="fw-600 ft-14 grey"
                style={{ width: item?.width, whiteSpace: "nowrap" }}
              >
                <div className="d-flex flex-row">
                  {item.columnName == "amount" && (
                    <AddToolTip
                      name={`Account Balance From – Greater than, Account Balance To – Lesser than or Equal to`}
                    >
                      <FontAwesomeIcon
                        className="mr-1 ft-16"
                        icon={faInfoCircle}
                      />
                    </AddToolTip>
                  )}
                  {item?.label}{" "}
                  <i
                    className="fas fa-sort-up fa-md ft-14"
                    style={{ paddingTop: "4px" }}
                    onClick={(e) =>
                      setPartcipantBalance(
                        [...participantBalance].sort(sorterUp(item.columnName))
                      )
                    }
                  ></i>
                  <i
                    className="fas fa-sort-down fa-md ft-14"
                    style={{ marginLeft: "-9px", paddingTop: "5px" }}
                    onClick={() => {
                      setPartcipantBalance(
                        [...participantBalance].sort(
                          sorterDown(item.columnName)
                        )
                      );
                    }}
                  ></i>
                </div>

                {/* <FontAwesomeIcon
              icon={faSortUp}
              size="xs"
              className="cursor-pointer grey sortUp"
              onClick={(e) =>
                setPartcipantBalance(
                  [...participantBalance].sort(sorterUp(item.columnName))
                )
              }
            />
            <FontAwesomeIcon
              icon={faSortDown}
              size="xs"
              className="cursor-pointer grey"
              onClick={() => {
                setPartcipantBalance(
                  [...participantBalance].sort(sorterDown(item.columnName))
                );
              }}
            /> */}
              </div>
            ))}
          </div>

          {participantBalance.map((item, index) => {
            return (
              <div>
                <TieredParticipantBalanceCard
                  participantBalance={item}
                  index={index}
                />
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

export default TieredParticiantBalance;
